class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.productTitle = this.dataset.productTitle;
    this.productUrl = this.dataset.productUrl;
    this.productImage = this.dataset.productImage;
    this.productPrice = this.dataset.productPrice;
    this.render();
    this.updateState();

    // Use touchend for instant mobile response — no 300ms delay
    this.addEventListener('touchend', this._onTouch.bind(this), { passive: false });
    this.addEventListener('click', this._onClick.bind(this));
    window.addEventListener('wishlist:updated', () => this.updateState());
  }

  _onTouch(e) {
    e.preventDefault();
    e.stopPropagation();
    this._didTouch = true;
    this.toggle();
  }

  _onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    // Skip if touchend already handled it (prevents double-fire on mobile)
    if (this._didTouch) { this._didTouch = false; return; }
    this.toggle();
  }

  getWishlist() {
    try { return JSON.parse(localStorage.getItem('mb_wishlist') || '[]'); } catch(e) { return []; }
  }

  saveWishlist(list) {
    localStorage.setItem('mb_wishlist', JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('wishlist:updated'));
  }

  isWishlisted() {
    return this.getWishlist().some(p => String(p.id) === String(this.productId));
  }

  toggle() {
    const list = this.getWishlist();
    if (this.isWishlisted()) {
      this.saveWishlist(list.filter(p => String(p.id) !== String(this.productId)));
    } else {
      list.push({ id: this.productId, title: this.productTitle, url: this.productUrl, image: this.productImage, price: this.productPrice });
      this.saveWishlist(list);
    }
    this.updateState();
  }

  updateState() {
    const btn = this.querySelector('.wishlist-btn');
    if (!btn) return;
    const wished = this.isWishlisted();
    btn.classList.toggle('is-wishlisted', wished);
    btn.setAttribute('aria-label', wished ? 'Remove from wishlist' : 'Save to wishlist');
  }

  render() {
    this.innerHTML = `<button class="wishlist-btn" type="button" aria-label="Save to wishlist" title="Save to wishlist">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
    </button>`;
  }
}

customElements.define('wishlist-button', WishlistButton);

function updateWishlistCount() {
  const count = JSON.parse(localStorage.getItem('mb_wishlist') || '[]').length;
  document.querySelectorAll('.wishlist-header-count').forEach(el => {
    el.textContent = count > 0 ? count : '';
    el.style.display = count > 0 ? 'inline-flex' : 'none';
  });
}

window.addEventListener('wishlist:updated', updateWishlistCount);
document.addEventListener('DOMContentLoaded', updateWishlistCount);